import { ModalFuncProps } from "@mapmycustomers/ui";
import { ModalFunctions } from "@mapmycustomers/ui/src";

import styles from "../EmailButton.module.scss";

const showRecipientConfirmationModal = (
  modal: ModalFunctions,
  params: Omit<ModalFuncProps, "className" | "onCancel" | "onOk" | "type">
): Promise<void> => {
  return new Promise((resolve, reject) => {
    modal.show({
      ...params,
      className: styles.confirmationModal,
      onCancel: () => reject(),
      onOk: () => resolve(),
      type: "confirm",
      width: 504,
    });
  });
};

export default showRecipientConfirmationModal;
